import { useState, useCallback } from "react";
import { message } from "antd";
import { fetchMarksMatrix as fetchMarksMatrixApi, bulkUpdateMarksMatrix, creatMarks } from "../../../../services/markService";
import { useTranslation } from "react-i18next";

type MatrixUpdate = { markId: string; mark: number | null };

export const useMatrixMarks = () => {
  const [matrix, setMatrix] = useState<any | null>(null);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const { t } = useTranslation()

  const loadMatrix = useCallback(async (classId: string, subjectId: string, semester: string) => {
    if (!classId || !subjectId || !semester) return;
    setLoading(true);
    try {
      const res = await fetchMarksMatrixApi(classId, subjectId, semester);
      setMatrix(res?.data);
    } catch (er) {
      console.error(er)
    } finally {
      setLoading(false);
    }
  }, []);

  const saveMatrix = useCallback(async (marks: MatrixUpdate[]) => {
    if (!marks || marks.length === 0) return;
    setSaving(true);
    try {
      await bulkUpdateMarksMatrix(marks);
      message.success(t("mark_matrix.succes_update_marks"));
    } catch (er) {
      console.error(er)
    } finally {
      setSaving(false);
    }
  }, []);



  const saveTeacherMatrix = useCallback(async (marks: any[]) => {
    if (!marks || marks.length === 0) return;
    try {
      setLoading(true);
      await creatMarks(marks);
      message.success(t("mark_matrix.succes_update_marks"));
      return true
    } catch (error) {
      console.error(error)
      return false;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    matrix,
    loading,
    saving,
    loadMatrix,
    saveMatrix,
    setMatrix,
    saveTeacherMatrix,
  };
};
